import { useEffect, useState } from 'react';
import type { Movie } from '@/types/movie';

interface ShareButtonProps {
  movie: Movie;
  onShared?: () => void;
}

export default function ShareButton({ movie, onShared }: ShareButtonProps) {
  const [toast, setToast] = useState('');

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(''), 2600);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const handleShare = async () => {
    const link = window.location.href;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(link);
        setToast('详情链接已复制，可直接分享给朋友（演示分享）');
      } else {
        setToast(`已生成《${movie.title}》分享信息（演示分享，未接入真实接口）`);
      }
    } catch {
      setToast(`《${movie.title}》分享卡片已生成（演示分享，未接入真实接口）`);
    }
    onShared?.();
  };

  return (
    <>
      <button
        type="button"
        onClick={handleShare}
        className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2.5 text-sm text-background-100 transition-colors hover:border-accent-500 hover:text-accent-300"
      >
        <i className="ri-share-forward-line" />
        分享
      </button>

      {toast && (
        <div className="fixed bottom-24 left-1/2 z-[70] w-[calc(100%-2rem)] max-w-md -translate-x-1/2 rounded-md bg-primary-950 px-4 py-3 text-center text-sm text-background-50 md:bottom-10">
          {toast}
        </div>
      )}
    </>
  );
}